/** 全局常量 */
// 表单字段类型
export const FORM_ITEM_TYPE = {
  INTEGER: 'integer',
  NUMBER: 'number',
  STRING: 'string',
  SELECT: 'select'
}